/* DSL Banner stack — manage multiple toast/banner notifications */
(function(){
  var stack;
  function ensure(){
    if (stack) return stack;
    stack = document.createElement("div");
    stack.className = "dsl-banner-stack";
    stack.setAttribute("aria-live", "polite");
    document.body.appendChild(stack);
    return stack;
  }
  function show(opts){
    ensure();
    var b = document.createElement("div");
    b.className = "dsl-banner dsl-banner--" + (opts.variant || "info");
    b.setAttribute("role", "status");
    b.innerHTML = "<span>" + (opts.text || "") + "</span><button class=\"dsl-banner__close\" aria-label=\"Sluit\">&times;</button>";
    stack.appendChild(b);
    var t = setTimeout(function(){ b.remove(); }, opts.duration || 4000);
    b.querySelector(".dsl-banner__close").addEventListener("click", function(){ clearTimeout(t); b.remove(); });
    return b;
  }
  window.DSL_BANNER = {show: show};
})();